import noty from '@/plugins/noty'

export const activeCallPresentNotification = noty({
  type: 'info',
  timeout: 5000,
  text: 'Please wait until the active call ends'
})

export const weAreCallingYouNotification = ({ phoneNumber }) => {
  return noty({
    type: 'info',
    queue: 'passthru-advice',
    text: `We are calling you on ${phoneNumber}. Please answer that phone to dial out to your customer. When you end the call, you can log your activity here.`
  })()
}

export const errorNotification = ({ message }) => {
  return noty({
    type: 'error',
    timeout: 10000,
    text: message
  })()
}

export const warningNotification = ({ message }) => {
  return noty({
    type: 'warning',
    timeout: 5000,
    text: message
  })()
}

export const infoNotification = ({ message }) => {
  return noty({
    type: 'info',
    timeout: 5000,
    text: message
  })()
}

export const failedToPlaceCallNotification = noty({
  type: 'error',
  timeout: 10000,
  text: 'Sorry, an error occurred and we could not place your call'
})

export const microphoneBlockedNotification = noty({
  type: 'error',
  timeout: 10000,
  text: 'You need to allow Jiminny access to your microphone to make calls'
})

export const offlineNotification = noty({
  type: 'error',
  timeout: 10000,
  text: 'There is no Internet connection'
})

export const highRttNotification = noty({
  type: 'warning',
  timeout: 10000,
  text: '<strong>You have high network latency</strong>. Your current network conditions can result in perceptible delays in audio.'
})

export const lowMosNotification = noty({
  type: 'warning',
  timeout: 10000,
  text: '<strong>You have poor network conditions</strong>. Your current network conditions may result in poor call quality or a dropped call.'
})

export const highJitterNotification = noty({
  type: 'warning',
  timeout: 10000,
  text: '<strong>You have high network jitter</strong>. Your current network conditions may result in audio quality problems on the call, such as crackling and choppy audio.'
})

export const highPacketLossNotification = noty({
  type: 'warning',
  timeout: 10000,
  text: '<strong>You have high packet loss</strong>. Your current network conditions may result in choppy audio or a dropped call.'
})

export const constantAudioInputLevelNotification = noty({
  type: 'warning',
  timeout: 10000,
  text: '<strong>Check your microphone volume</strong>. Your current microphone settings may prevent you from being heard.'
})

export const constantAudioOutputLevelNotification = noty({
  type: 'warning',
  timeout: 10000,
  text: '<strong>Check your speaker connection</strong>. Your current speaker settings may prevent you from hearing audio.'
})



// WEBPACK FOOTER //
// ./src/components/rep-call/notifications.js